import { format } from "date-fns";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { AnalyticsEmailEvent } from "@/services/analyticsService";

interface EmailEventDetailsPanelProps {
  event: AnalyticsEmailEvent | null;
  isOpen: boolean;
  onClose: () => void;
}

export function EmailEventDetailsPanel({ event, isOpen, onClose }: EmailEventDetailsPanelProps) {
  if (!event) return null;

  const formatDate = (dateString: string) => {
    return format(new Date(dateString), "MMM dd, yyyy HH:mm:ss");
  };

  const getStatusBadgeVariant = (status: string) => {
    if (status === "faulted") {
      return "destructive";
    }
    return "default";
  };

  return (
    <Sheet open={isOpen} onOpenChange={onClose}>
      <SheetContent className="w-[480px] sm:max-w-[480px]">
        <SheetHeader>
          <SheetTitle>Email Event Details</SheetTitle>
          <SheetDescription>
            Detailed information for email event
          </SheetDescription>
        </SheetHeader>

        <div className="mt-6 space-y-6">
          <div className="space-y-4">
            <div>
              <label className="text-sm font-medium text-muted-foreground">Status</label>
              <div className="mt-1">
                <Badge variant={getStatusBadgeVariant(event.status)}>
                  {event.status}
                </Badge>
              </div>
            </div>

            <div>
              <label className="text-sm font-medium text-muted-foreground">Created At</label>
              <div className="mt-1 text-sm">{formatDate(event.created_at)}</div>
            </div>

            <div>
              <label className="text-sm font-medium text-muted-foreground">Processed At</label>
              <div className="mt-1 text-sm">
                {event.processed_at ? formatDate(event.processed_at) : 'Not processed yet'}
              </div>
            </div>

            <div>
              <label className="text-sm font-medium text-muted-foreground">Correlation ID</label>
              <div className="mt-1 text-sm font-mono text-xs break-all">
                {event.correlation_id || 'No correlation ID'}
              </div>
            </div>
          </div>

          <Separator />

          <div>
            <label className="text-sm font-medium text-muted-foreground">Process Log</label>
            <div className="mt-2">
              {event.process_log ? (
                <pre className="text-xs bg-muted p-3 rounded-md overflow-auto max-h-96 whitespace-pre-wrap">
                  {JSON.stringify(event.process_log, null, 2)}
                </pre>
              ) : (
                <div className="text-sm text-muted-foreground italic">No process log available</div>
              )}
            </div>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}